export const currentUser = state => state.user.main
export const currentLawFirm = state => state.lawFirms.lawFirms[state.lawFirms.selected]
export const unreadNotificationsCount = state => state.notifications.main.length
